<template>
  <div>
    <portal to="toolbar-title"> Ιστορικό Γεγονότων</portal>
    <portal to="toolbar-actions"></portal>
    <v-dialog v-model="dialog" :fullscreen="isMobile" :max-width="!isMobile?'1200px':''"
              transition="dialog-bottom-transition">
      <v-card class="background">
          <event-card v-if="activeEvent" :key="activeEvent.Event_ID" :event-id="activeEvent.Event_ID">
            <template v-slot:beforeTitle>
              <v-btn icon @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
        </event-card>
      </v-card>
    </v-dialog>

    <single-page >
      <template v-slot:toolbar-title>
        {{ filters.dateFrom |fullDate }} - {{ filters.dateTo |fullDate }}
      </template>
      <template v-slot:main-sidebar>
        <div>
          <v-card class="mb-6">
            <div  class="">
              <v-col lg="6">
                <label style="font-size: 0.7em" for="dateFrom"> Από </label>
                <br>
                <input style="border-bottom: grey 1px solid; padding-top: 0" id="dateFrom" type="date"
                       v-model="filters.dateFrom">
              </v-col>
              <v-col lg="6">
                <label style="font-size: 0.7em" for="date"> Eώς </label>
                <br>
                <input style="border-bottom: grey 1px solid; padding-top: 0" id="date" type="date"
                       v-model="filters.dateTo">
              </v-col>
              <v-col cols="12">
                <v-btn class="ma-4" color="primary" @click="eventDateSearch()"> ΦΙΛΤΡΑΡΙΣΜΑ</v-btn>
              </v-col>
            </div>
          </v-card>
          <filters module-name="DataGridHandler">
          </filters>
        </div>
      </template>
      <template v-slot:toolbar-items>
        <v-btn-toggle v-if="!isMobile" dense background-color="transparent" borderless v-model="activeView">
          <v-btn text value="table">
            <v-icon class="mr-1"> mdi-table</v-icon>
            ΠΙΝΑΚΑΣ
          </v-btn>
          <v-btn text value="calendar">
            <v-icon class="mr-1"> mdi-calendar</v-icon>
            ΗΜΕΡΟΛΟΓΙΟ
          </v-btn>
        </v-btn-toggle>
        <print-pdf-button id-to-print="table" :page-title="filters.dateFrom +'-'+filters.dateTo"></print-pdf-button>
      </template>


      <template v-slot:main-content>
        <v-card>
          <active-filters module-name="DataGridHandler"/>
          <v-data-iterator
              v-if="isMobile && activeView === 'table' && data.length >= 100"
              :items="data"
              :items-per-page="15"
          >
          <template v-slot:item="props">
            <event-mobile-item
                :key="props.item.Event_ID"
                @click="rowClick(props.item)"
                :item="props.item"
            />
          </template>
          </v-data-iterator>
          <v-list v-if="isMobile && activeView === 'table' && data.length<100 && data.length">
            <event-mobile-item :key="i.Event_ID" @click="rowClick(i)" v-for="i in data" :item="i"/>
          </v-list>
          <v-card-text v-if="data.length===0">
            Δεν βρέθηκαν γεγονότα σε αυτό το διάστημα
          </v-card-text>

          <v-data-table
              :items-per-page="15"
              v-if="data.length"
              :class="{'hidden':(isMobile || activeView !== 'table')}" id="table" @click:row="rowClick"
              :headers="headers"
              :items="data"
              fixed-header height="76vh">
            <template v-slot:item.DateEventInsert="{item}">
              <span v-if="item.EventType_ID === 1">{{ item.DateStart | fullDate }}</span>
              <span v-else> {{ item.DateEventInsert | fullDate }}</span>
            </template>
            <template v-slot:item.EventType_ID="{item}">
              <v-chip  v-if="item.EventType_ID === 1" color="maintenance" >
                <v-icon> mdi-wrench-outline</v-icon>
                Συντήρηση
              </v-chip>
              <v-chip  v-else-if="item.EventType_ID === 2" color="callout" >
                <v-icon> mdi-alert-outline</v-icon>
                Βλάβη
              </v-chip>
              <v-chip  v-else-if="item.EventType_ID === 3" color="task" > Άλλη εργασία
              </v-chip>
            </template>
          </v-data-table>

          <div v-if="activeView === 'calendar'">
            <v-layout align-content-space-between align-center  justify-space-between >
              <v-btn
                  class="ma-2"
                  @click="$refs.calendar.prev()"
              >
                <v-icon> mdi-chevron-left</v-icon>
                {{ calendarPreviousMonth | month }}
              </v-btn>
              <span> {{calendarNowMonth | month}}</span>
              <v-btn
                  class="ma-2"
                  @click="$refs.calendar.next()"
              >
                {{calendarNextMonth | month}}
                <v-icon> mdi-chevron-right</v-icon>
              </v-btn>
            </v-layout>
            <v-calendar
                v-model="value"
                ref="calendar"
                :events="eventCalendar" :type="calendarType"
                v-if="activeView==='calendar'"
                :event-color="(e)=>e.color"
                @click:event="calendarEventClick"
            >

            </v-calendar>

          </div>
        </v-card>
      </template>
    </single-page>


  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import store from "../../../store";
import events from "../../../wl-core/api/sectors/events";
import moment from "moment";
import dataGridHandler from "../../../wl-datagrid-handler/dataGridHandler";
import Filters from "../../../wl-datagrid-handler/Filters";
import ActiveFilters from "../../../wl-datagrid-handler/ActiveFilters";
import EventCard from "../components/EventCard";
import IssueItem from "../../Issues/components/IssueListItem";
import EventItem from "../components/EventItem";
import EventMobileItem from "../components/EventMobileItem";
import FiltersModal from "../../../wl-datagrid-handler/FiltersModal";
import backButton from "../../../wl-core/mixins/backButton";
import SinglePage from "@/components/templates/SinglePage";
import PrintPdfButton from "@/components/PrintPdfButton";

export default {
  name: "EventHistoryMobile",
  components: {PrintPdfButton, SinglePage, FiltersModal, EventCard, EventMobileItem, EventItem, ActiveFilters, Filters},
  mixins: [backButton(['dialog'])],
  data: () => ({
    events: [],
    value: '',
    activeEvent: null,
    dialog: false,
    modal: false,
    activeView: 'table',
    calendarType: 'month',
    filteredEvents: [],
    filters: {
      dateFrom: moment(Date.now()).subtract(365, 'days').format('YYYY-MM-DD'),
      dateTo: moment(Date.now()).format('YYYY-MM-DD'),
    },

    activeFilters: {
      eventType: null,
      eventBuilding: null,
    },

    eventFilters: {
      eventTypes: [],
      eventCustomers: [],
      eventBuilding: []
    },
    headers: []
  }),
  beforeCreate() {
    store.registerModule('DataGridHandler', dataGridHandler);
  },
  created() {
    this.headers = [
      {
        text: 'Hμ/νια ',
        value: 'DateEventInsert',
        filterable: true,
        width: "100"
      },
      {
        text: 'Tύπος',
        value: 'EventType_ID',
        filterable: true,
        width: "100"
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        filterable: true,
      },
      {
        text: 'Κτήριο',
        value: 'BranchAddress',
        filterable: true,
        width: "150"
      },
      {
        text: 'Περιοχή',
        value: 'BranchAreaName',
        width: "100"
      },
      {
        width: "100",
        sortable: false,
        text: this.$unitText('Ανυψωτικό'),
        value: 'ProjectName'
      },
    ]
    this.eventDateSearch();
  },
  computed: {
    calendarNowMonth(){
      return moment(this.value ? this.value : Date.now()).format('YYYY-MM-DD')
    },
    calendarPreviousMonth() {
      return moment(this.value ? this.value : Date.now()).subtract(1, 'months').format('YYYY-MM-DD')
    },
    calendarNextMonth(){
      return moment(this.value ? this.value : Date.now()).add(1, 'months').format('YYYY-MM-DD')
    },
    ...mapGetters([
      "isMobile"
    ]),
    eventCalendar() {
      return this.data.map(e => ({
        name: e.BranchAddress + "-" + e.ProjectName,
        start: new Date(e.getCalendarStart()),
        end: new Date(e.DateEnd),
        color: e.getColor(),
        event: e
      }))
    },
    ...mapGetters('DataGridHandler', [
      "data"
    ])
  },
  beforeDestroy() {
    this.$store.unregisterModule('DataGridHandler');
  },
  methods: {
    calendarEventClick({nativeEvent, event}) {
      this.rowClick(event.event)
    },
    rowClick(event) {
      this.activeEvent = event;
      this.dialog = true;
    },
    setEvents(events) {
      this.events = events;
      this.events.forEach(e => e.EventName = this.getEventName(e.EventType_ID));
      this.setData(this.events);
      this.createFilters([
        {key: 'EventName', name: 'Τύπος'},
        {key: 'BranchAddress', name: 'Κτήρια'},
        {key: 'StatusName', name: 'Κατάσταση'}
      ]);
    },
    eventDateSearch() {
      this.getAllEvents({DateFrom: this.filters.dateFrom, DateTo: this.filters.dateTo}).then(
          events => {
            this.toggleModal();
            return this.setEvents(events)
          }
      )
    },
    getEventName(number) {
      let names = {1: 'Συντήρηση', 2: 'Βλάβη', 3: 'Άλλη Εργασία'};
      return names[number];
    },

    ...mapActions([
      "exportToExcel",
      "getAllEvents",
    ]),
    ...mapMutations('DataGridHandler', [
      "clearAllFilters",
      "clearFilter",
      "setData",
      "addFilter",
      "createFilters",
      "toggleModal",
    ])
  }
}
</script>

<style scoped>
.hidden {
  display: none;
}

</style>
